export default function FujiMoneyIcon() {
  return <img height='55' width='55' src='/fuji-money.jpg' style={{ borderRadius: '50%' }} />
}
